import App from './App.svelte';
import 'bootstrap-italia/dist/js/bootstrap-italia.bundle.min.js';
import './styles/bootstrap-italia-comuni.css';

export default function(target, props) {

	if(!target || !props) {
		throw new Error('App init failed. Missing target or props');
	}

	new App({
		target,
		props
	});
}
